export class Watcher {
  id: number;
  userID: number;
  entityID: number;
  entityType: EntityTypeEnum;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  createdBy: number;
  user: WatcherUser;
  createdByUser: WatcherUser;
}

export class WatcherUser {
  id: number;
  firstName: string;
  lastName: string;
  tenantId: number;
}

export enum EntityTypeEnum {
  JOB_OFFER = 'JOB_OFFER',
  CANDIDATE = 'CANDIDATE',
  USER = 'USER',
  TENANT = 'TENANT',
}

export class GetWatchersRequestData {
  entityId: number;
  entityType: EntityTypeEnum;
}

export class CreateWatcherRequestData {
  entityType: EntityTypeEnum;
  entityId: number;
  userId: number;
}
